export const API_AUTH_ERROR_TOKENS = ['no_token_present', 'access_denied', 'token_expired']
